import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { useCookieConsent } from "@/components/CookieConsentContext";
import { API } from "@/lib/api";

export const REFERRAL_STORAGE_KEY = "endosmundos_affiliate_referral_v1";

function readReferral() {
  try {
    const referral = JSON.parse(localStorage.getItem(REFERRAL_STORAGE_KEY));
    if (referral?.token && referral?.expires_at && new Date(referral.expires_at) > new Date()) return referral;
  } catch {
    return null;
  }
  localStorage.removeItem(REFERRAL_STORAGE_KEY);
  return null;
}

export function AffiliateAttribution() {
  const location = useLocation();
  const { consent } = useCookieConsent();

  useEffect(() => {
    if (!consent.affiliate) return;
    const referralCode = new URLSearchParams(location.search).get("ref")?.trim();
    if (!referralCode) return;

    const existing = readReferral();
    if (existing?.referral_code === referralCode.toUpperCase()) return;

    let cancelled = false;
    axios.post(`${API}/affiliates/click`, { referral_code: referralCode })
      .then(({ data }) => {
        if (!cancelled) {
          localStorage.setItem(REFERRAL_STORAGE_KEY, JSON.stringify({
            referral_code: referralCode.toUpperCase(),
            token: data.referral_token,
            expires_at: data.expires_at,
          }));
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [consent.affiliate, location.search]);

  return null;
}

export function getActiveReferralToken() {
  return readReferral()?.token || "";
}

export function getActiveReferralCode() {
  const queryCode = new URLSearchParams(window.location.search).get("ref")?.trim();
  if (queryCode) return queryCode.toUpperCase();
  return readReferral()?.referral_code || "";
}

export function appendAffiliateCodeToWhatsApp(url) {
  const referralCode = getActiveReferralCode();
  if (!referralCode) return url;
  const target = new URL(url);
  const message = target.searchParams.get("text") || "";
  if (message.includes("Código de recomendación:")) return url;
  target.searchParams.set("text", `${message}\nCódigo de recomendación: ${referralCode}`);
  return target.toString();
}

export function withAffiliateCode(path) {
  const referralCode = getActiveReferralCode();
  if (!referralCode) return path;
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}ref=${encodeURIComponent(referralCode)}`;
}
